import { render, staticRenderFns } from "./StudentRelationsRosterProfileSectionList.vue?vue&type=template&id=f71d7230&"
import script from "./StudentRelationsRosterProfileSectionList.vue?vue&type=script&lang=js&"
export * from "./StudentRelationsRosterProfileSectionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports